const statuses = [
    { code: 'active', name: 'Pending' },
    { code: 'pending_today', name: 'Pending Today' },
    { code: 'pending_unconfirmed', name: 'Pending - Unconfirmed' },
    { code: 'pending_confirmed', name: 'Pending - Confirmed' },
    { code: 'auto', name: 'Auto' },
    { code: 'approved', name: 'Approved' },
    { code: 'rejected', name: 'Rejected' },
    { code: 'draft', name: 'At work' },
    { code: 'logs_today', name: 'Gone home' },
];

export const checklist_status = [
    { code: 'New', name: 'New' },
    { code: 'Under work', name: 'Pending' },
    { code: 'Pending', name: 'Done' },
    { code: 'Approved', name: 'approved' },
];

export const users_statuses = [
    { code: 'working_now', name: 'At work' },
    { code: 'users_not_at_work', name: 'Not at work' },
];

export const statusMap = {
    active: 'Pending',
    auto: 'Auto',
    approved: 'approved',
    rejected: 'rejected',
    draft: 'At work',
};

export const roster_statuses = {
    published: 'Published',
    active: 'Active',
    approved: 'Approved',
    rejected: 'Rejected',
    draft: 'Draft',
    expired: 'Expired',
};

export const leave_type_status = [
    { code: 'paid', name: 'Paid' },
    { code: 'unpaid', name: 'Unpaid' },
]

export const absence_and_vacation_statuses = [
    { code: 'active', name: 'Pending' },
    { code: 'approved', name: 'Approved' },
    { code: 'rejected', name: 'Rejected' },
    { code: 'cancelled', name: 'Cancelled' },
]

export const serviceRequestStatusMap = {
    active: 'Pending',
    approved: 'Done',
    ongoing: 'In Progress',
}

export const service_request_statuses = [
    { code: 'active', name: 'Pending' },
    { code: 'ongoing', name: 'In Progress' },
    { code: 'approved', name: 'Done' }
]

export const work_pattern_assignment_statuses = [
    { code: 'active', name: 'Active' },
    { code: 'inactive', name: 'Inactive' },
];

export const timeBankStatusMap = {
    active: 'Pending',
    approved: 'Approved',
    sent: 'Sent',
    comp_off: 'Comp-off'
}

export const user_type_map = {
    admin: 'Admin',
    pm: 'PM',
    member: 'Member',
}

export const overtime_transaction_types = [
    { code: 'credit', name: 'Increase' },
    { code: 'debit', name: 'Decrease' },
]

export const overtime_transaction_type_map = {
    credit: 'Increase',
    debit: 'Decrease',
}

export const overtime_transaction_type_color_map = {
    credit: '#16A34A',
    debit: '#DC2626',
}

export const overtime_transaction_overtime_types = [
    { code: 'daily', name: 'Daily' },
    { code: 'weekly', name: 'Weekly' },
    { code: 'paid', name: 'Paid' },
    { code: 'urgent', name: 'Urgent Work' },
    { code: 'mandatory', name: 'Mandatory' },
]

export const overtime_transaction_overtime_type_map = {
    daily: 'Daily',
    weekly: 'Weekly',
    paid: 'Paid',
    urgent: 'Urgent Work',
    mandatory: 'Mandatory',
}

export const overtime_transaction_overtime_type_color_map = {
    daily: '#2550ac',
    weekly: '#8B5CF6',
    paid: '#16A34A',
    urgent: '#DC2626',
    mandatory: '#F59E0B',
    average_overtime: '#46dad3',
}

export const overtime_type_color_map = {
    ...overtime_transaction_overtime_type_color_map,
    mixed: '#888888',
}

export const overtime_transaction_status_map = {
    active: 'Active',
    approved: 'Approved',
    sync_success: 'Synced',
    sync_failed: 'Sync Failed',
    moved_to_timebank: 'Moved to Timebank',
}

export const overtime_transaction_status_color_map = {
    active: '#ff8c00',
    approved: '#16A34A',
    sync_success: '#16A34A',
    sync_failed: '#DC2626',
    moved_to_timebank: '#2550ac',
}

export default statuses;
